import EDR1RXD1 from '../../../assets/images/cpg-products/EDR1RXD1.png';
import EDR2RXD1 from '../../../assets/images/cpg-products/EDR2RXD1.png';
import EDR3RXD1 from '../../../assets/images/cpg-products/EDR3RXD1.png';
import EDR4RXD1 from '../../../assets/images/cpg-products/EDR4RXD1.png';
import EDR5RXD1 from '../../../assets/images/cpg-products/EDR5RXD1.png';
import EDR6D1 from '../../../assets/images/cpg-products/EDR6D1.png';
import EDRARXD1 from '../../../assets/images/cpg-products/EDRARXD1.png';
import F2WC9I1 from '../../../assets/images/cpg-products/F2WC9I1.png';
import SWHLDLFL2S from '../../../assets/images/cpg-products/SWHLDLFL2S.png';
import W10549851 from '../../../assets/images/cpg-products/W10549851.png';
import W11179302 from '../../../assets/images/cpg-products/W11179302.png';
export type CPGImage = {
  id: string;
  image: string;
};
export const cpgImages: ReadonlyArray<Record<string, string>> = [
  { id: 'EDR1RXD1', image: EDR1RXD1 },
  { id: 'EDR2RXD1', image: EDR2RXD1 },
  { id: 'EDR3RXD1', image: EDR3RXD1 },
  { id: 'EDR4RXD1', image: EDR4RXD1 },
  { id: 'EDR5RXD1', image: EDR5RXD1 },
  { id: 'EDR6D1', image: EDR6D1 },
  { id: 'EDRARXD1', image: EDRARXD1 },
  { id: 'F2WC9I1', image: F2WC9I1 },
  { id: 'SWHLDLFL2S', image: SWHLDLFL2S },
  { id: 'W10549851', image: W10549851 },
  { id: 'W11179302', image: W11179302 },
];
